import React, {useEffect, useState} from 'react';
import {getUserEnrollments} from '../../../services/enrollments'
import ScaleLoader from "react-spinners/ScaleLoader";
import {useAuth, withAuth} from "../../../contexts/authContext";
import {Button, Col, Container, Row} from "react-bootstrap";
import {replaceOriginalPartner} from "../../../services/users";
import history from "../../../history";
import withReactContent from 'sweetalert2-react-content';
import Swal from "sweetalert2";
import parse from "html-react-parser";
import {useTranslation} from "react-i18next";

// React Components
import Header from "../../../components/Header";
import BulletHeader from "../../../components/BulletHeader/BulletHeader";
import NoRegistrationsAlert from "../../../components/NoRegistrationsAlert";

// Icons
import ChangeCircleIcon from "../../../assets/images/changecircle.svg";

// CSS Files
import './styles.css';

const override = `
    display: block;
    text-align: center;
    margin-top: 10%;
    `;

const MySwal = withReactContent(Swal);

const MainPage = (props) => {
   const [substitutionData, setSubstitutionData] = useState({});
   const [loading, setLoading] = useState(false);
   const auth = useAuth();
   const {t} = useTranslation();

   const updateData = async () => {
      try {
         let enrollment = auth.user.active_enrollment;

         const params = {
            league_category_id: enrollment.league_category_id,
            league_division_id: enrollment.league_division_id,
            league_edition_id: enrollment.league_edition_id,
            league_id: enrollment.league_id
         };

         setLoading(true);
         const substitutionData = await getUserEnrollments(params);
         setSubstitutionData(substitutionData);
      } catch (error) {

      } finally {
         setLoading(false);
      }
   };

   const returnOriginalPartner = async () => {
      MySwal.fire({
         showCancelButton: true,
         titleText: t("common.confirm"),
         text: t("substitutions_page.confirm_return_alert"),
         confirmButtonText: t("common.confirm"),
         cancelButtonText: t("common.cancel")
      }).then(async (res) => {
         if (res.dismiss != 'cancel') {
            const response = await replaceOriginalPartner(substitutionData.enrollments[1]);

            MySwal.fire({
               showCancelButton: false,
               titleText: t("substitution_request_page.request_submitted"),
               text: t("substitution_request_page.wait_for_approval"),
               confirmButtonText: "Ok"
            }).then(async (res) => {
               await updateData();
            });
         }
      });
   };

   useEffect(() => {
      (async () => {
         await updateData();
      })()
   }, [auth.user.active_enrollment]);

   return (
      <div>
         <Header headerBarTitle={t("substitutions_page.header")} showHeaderExtras/>
         <Container className={"desktop pb-3"}>
            <ScaleLoader
               css={override}
               sizeUnit={"px"}
               size={30}
               color={'#AFFF55'}
               loading={loading}
            />
            {substitutionData.enrollments && substitutionData.enrollments.length > 0 ? (
               <>
                  {(substitutionData.first_substitution || (!substitutionData.first_substitution && !substitutionData.second_substitution && !substitutionData.substitution_pending)) &&
                     <>
                        <Row>
                           <Col xs={12}>
                              <div className={"w-100 mt-3 mb-3 text-center"}>
                                 <label className={"form-label"}>{t("substitutions_page.partner")}</label>
                              </div>
                           </Col>
                        </Row>
                        <Row className={"pb-2 pt-4"}>
                           <Col xs={{span: 4, offset: 4}} md={{span: 4}}>
                              <img className={"position-absolute changecircleicon"} src={ChangeCircleIcon}/>
                              <div className={"profilefoto"} style={{backgroundImage: "url(" + substitutionData.enrollments[0].team.partner.photo_url + ")"}}/>
                           </Col>
                        </Row>
                        <Row>
                           <Col xs={12} className={"text-center mt-3 mb-3"}>
                              <BulletHeader text={substitutionData.enrollments[0].team.partner.name}/>
                           </Col>
                        </Row>
                     </>
                  }
                  {(substitutionData.second_substitution || substitutionData.substitution_pending) &&
                     <>
                        <Row className={"pt-5 mb-5"}>
                           <Col xs={5}>
                              <Row>
                                 <Col xs={12}>
                                    <div className={"w-100 mt-3 mb-3 text-center"}>
                                       <label className={"form-label"}>{t("substitutions_page.original_partner")}</label>
                                    </div>
                                 </Col>
                              </Row>
                              <Row className={"pb-2 pt-2"}>
                                 <Col xs={{span: 4, offset: 4}} md={{span: 2, offset: 5}}>
                                    <div className={"profilefoto"} style={{backgroundImage: "url(" + substitutionData.enrollments[0].team.partner.photo_url + ")"}}/>
                                 </Col>
                              </Row>
                              <Row>
                                 <Col xs={12} className={"text-center mt-3 mb-3 confirmation-nomeparceiro"}>
                                    <BulletHeader text={substitutionData.enrollments[0].team.partner.name}/>
                                 </Col>
                              </Row>
                           </Col>
                           <Col xs={2} className={"d-flex align-items-center"}>
                              <img className={"img-fluid"} src={ChangeCircleIcon}/>
                           </Col>
                           <Col xs={5}>
                              <Row>
                                 <Col xs={12}>
                                    <div className={"w-100 mt-3 mb-3 text-center"}><label className={"form-label"}>{t("substitutions_page.new_partner")}</label></div>
                                 </Col>
                              </Row>
                              <div className={substitutionData.substitution_pending ? "pending-transparency" : ""}>
                                 <Row className={"pb-2 pt-2"}>
                                    <Col xs={{span: 4, offset: 4}} md={{span: 2, offset: 5}}>
                                       <div className={"profilefoto"} style={{backgroundImage: "url(" + substitutionData.enrollments[1].team.partner.photo_url + ")"}}/>
                                    </Col>
                                 </Row>
                                 <Row>
                                    <Col xs={12} className={"text-center mt-3 mb-3 confirmation-nomeparceiro"}>
                                       <BulletHeader text={substitutionData.enrollments[1].team.partner.name}/>
                                    </Col>
                                 </Row>
                              </div>
                           </Col>
                        </Row>
                     </>
                  }
                  {substitutionData.warning_message &&
                     <Row className={"justify-content-center"}>
                        <Col xs={9} className={"text-center warning"}>
                           <p>
                              {parse(substitutionData.warning_message + "")}
                           </p>
                        </Col>
                     </Row>}
                  {substitutionData.first_substitution &&
                     <Row className={"mt-4"}>
                        <Container className={"desktop"}>
                           <Col xs={12} m={'auto'}>
                              <Button onClick={() => {
                                 history.push("/substitutions/new");
                              }} className="btn-primary w-100">{t("substitutions_page.substitute")}</Button>
                           </Col>
                        </Container>
                     </Row>
                  }
                  {substitutionData.second_substitution &&
                     <Row className={"mt-4"}>
                        <Container className={"desktop"}>
                           <Col xs={12} m={'auto'}>
                              <Button disabled={loading} onClick={() => {
                                 returnOriginalPartner();
                              }} className="btn-primary w-100">{loading ? t("common.please_wait") : t("substitutions_page.return_original_partner")}</Button>
                           </Col>
                        </Container>
                     </Row>}
               </>
            ) : (
               <NoRegistrationsAlert
                  text={t("common.no_registrations")}
               />
            )
            }

         </Container>
      </div>
   );
}

export default withAuth(MainPage);